'use client'

import { useRef } from 'react'
import Image from 'next/image'
import type { HeroSimpleWithImageFragment } from '@/lib/types/datocms/graphql/generated'
import { TextWithHighlight } from '../TextWithHighlight'
import { StructuredText } from 'react-datocms'

export default function HeroSimpleWithImage({
	title,
	image,
	description,
}: Readonly<HeroSimpleWithImageFragment>) {
	const ref = useRef<HTMLDivElement>(null)

	return (
		<section
			ref={ref}
			className="hero-simple-with-image relative bg-cover bg-center min-h-[440px] flex items-center mt-[--nav-height] after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-b after:from-black/10 after:to-transparent before:content-[''] before:absolute before:inset-0 before:bg-black/10 @container"
		>
			{image ? (
				<Image
					src={image[0].url}
					alt={image[0].alt}
					width={image[0].width}
					height={image[0].height}
					className="absolute inset-0 w-full h-full object-cover -z-10"
					priority
				/>
			) : null}

			<div className="max-w-screen-2xl mx-auto flex flex-col gap-3 @3xl:text-center text-white px-3 py-6 @5xl:p-10 @5xl:justify-between">
				{/* Title */}
				{title ? (
					<h1 className="heading-size-1 max-w-3xl @3xl:mx-auto @5xl:max-w-5xl z-10">
						<TextWithHighlight text={title} />
					</h1>
				) : null}

				{/* Description */}
				{description ? (
					<div className="text-xl @5xl:text-2xl z-10">
						<StructuredText data={description} />
					</div>
				) : null}
			</div>
		</section>
	)
}
